export const LOGIN = 'LOGIN'
export const ERROR_DISMISS = 'ERROR_DISMISS'
export const PROMISE_ERROR = 'PROMISE_ERROR'
export const SET_PAYMENT_SETTINGS = 'SET_PAYMENT_SETTINGS'